import { FC, useCallback, useEffect, useState } from "react";
import { t } from "i18next";
import { useSelector } from "react-redux";

import BookingCalendar from "@components/Booking/BookingCalendar/BookingCalendar";
import TimeSlot from "@components/Booking/TimeSlot/TimeSlot";
import { slotType } from "@enums/hooks.enum";
import { useBooking } from "@hooks/useBooking/useBooking";
import { BookingTimeSelect } from "@models/components/booking.model";
import { RootState } from "@store/index";

const TimeSelect: FC<BookingTimeSelect> = ({
  bookingLoader,
  checkBookingDisable,
  slots,
}) => {
  const [selectedSlotGroup, setSelectedSlotGroup] = useState<string>("");

  const { selectedSlot, selectedTime, timeMaps } = useSelector(
    (State: RootState) => State.booking
  );
  const showCalendarSection = useSelector(
    (State: RootState) => State.app.showCalendarSection
  );
  const { buildTimeSlot } = useBooking();

  // Create a memoized callback for updating the selectedSlotGroup
  const handleSelectedSlotGroupChange = useCallback((value: string) => {
    setSelectedSlotGroup(value);
  }, []);

  const isReservationSlotActive =
    selectedSlot?.slot?.type === slotType?.ReservationSlots;

  useEffect(() => {
    buildTimeSlot(slots);
    setSelectedSlotGroup("");
  }, []);

  useEffect(() => {
    buildTimeSlot(slots);
  }, [slots]);

  return (
    <>
      {!!showCalendarSection && slots?.showCalendar ? (
        <BookingCalendar slots={slots} bookingLoader={bookingLoader} />
      ) : (
        <>
          {timeMaps?.length === 0 && selectedTime === "" && (
            <div className="alert alert-danger small p-2 mt-2">
              {t("noSlotsAvailableForBooking")}
            </div>
          )}
          {timeMaps.length > 0 && (
            <div className="fg-time-bubbles mt-2">
              <h4 className="mb-4 fg-booking-subheading">
                {t("selectStartTime")}
              </h4>
              <TimeSlot
                selectedSlotGroup={selectedSlotGroup}
                setSelectedSlotGroup={handleSelectedSlotGroupChange}
                isReservationSlotActive={isReservationSlotActive}
                isBookingDisable={checkBookingDisable}
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default TimeSelect;
